import { TranslocoService } from '@jsverse/transloco';
import { combineLatest, map, Observable } from 'rxjs';

import { DeviceUiPage, DeviceUiRoute } from '@shure/device-ui/shared/services';
import { DeviceUiShellDeviceBehaviorPlugin } from '@shure/device-ui/shell/data-access';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceBehaviorPlugin } from '@shure/shared/angular/device-behavior/core';
import { shUseTranslation } from '@shure/shared/angular/utils/i18n';

@shUseTranslation('scDevUiSharedDevBehavior', (lang) => import(`../i18n/${lang}`))
export class MxcwNcxDeviceUiDeviceBehaviorPlugin implements DeviceBehaviorPlugin, DeviceUiShellDeviceBehaviorPlugin {
	public readonly models: DeviceModel[] = [DeviceModel.MXCWNCX];

	constructor(protected readonly transloco: TranslocoService) {}

	public getAvailablePages$(_model: DeviceModel): Observable<DeviceUiPage[] | undefined> {
		return combineLatest([
			this.transloco.selectTranslate('scDevUiSharedDevBehavior.toolbar.labels.charger-bays'),
			this.transloco.selectTranslate('scDevUiSharedDevBehavior.toolbar.labels.settings')
		]).pipe(
			map(([chargerBaysLabel, settingsLabel]) => [
				{ route: DeviceUiRoute.ChargerBays, label: chargerBaysLabel },
				{ route: DeviceUiRoute.Settings, label: settingsLabel }
			])
		);
	}

	public getDefaultRoute(_model: DeviceModel): DeviceUiRoute | undefined {
		return DeviceUiRoute.Settings;
	}
}
